import { gql } from '@apollo/client';

export const SET_HOTEL_EMPLOYEE_ROLE = gql`
  mutation SetHotelUserRole($userId: ID!, $newRole: ENUM_USERSPERMISSIONSUSER_DASHBOARDROLE!) {
    updateUser(input: { where: { id: $userId }, data: { dashboardRole: $newRole } }) {
      user {
        id
        dashboardRole
        username
      }
    }
  }
`;
